import { useEffect, useState } from "react";

import { MappedSearchHierarchyNodeResponse, getMappedSearchHierarchyNodeResponse } from "./node-service-helpers";
import { searchHierarchByFieldCompanyId, getHierarchyNodeById, GetHierarchyNodeResponse } from "./node-service";

export type ApiCallState<TResponse> = {
    loading: boolean;
    error: Error | null;
    data: TResponse | null;
    refresh?: () => void | undefined;
};

export type UseHierarchyNodeResult = {
    loading: boolean;
    error: Error | null;
    data: MappedSearchHierarchyNodeResponse | null;
    refresh: () => void;
}

export function useHierarchyNodesSearchById(fieldCompanyId: number) : UseHierarchyNodeResult {
    const [state, setState] = useState<ApiCallState<MappedSearchHierarchyNodeResponse>>({
        data: null,
        error: null,
        loading: false,
    });

    const [refreshIndex, setRefreshIndex] = useState(0);

    useEffect(() => {
        setState({ data: null, error: null, loading: true });
        (async () => {
            try {
                const data = await searchHierarchByFieldCompanyId(fieldCompanyId);

                const mappedSearchHierarchyNodeResponse = getMappedSearchHierarchyNodeResponse(data);

                setState({ data: mappedSearchHierarchyNodeResponse, error: null, loading: false });
            } catch (error: any) {
                setState({ data: null, error, loading: false });
            }
        })();
    }, [fieldCompanyId, refreshIndex]);

    return {
        ...state,
        refresh: () => setRefreshIndex(refreshIndex + 1),
    };
}

export function useGetHierarchyNodeById(id: number): ApiCallState<GetHierarchyNodeResponse> {
    const [state, setState] = useState<ApiCallState<GetHierarchyNodeResponse>>({
        data: null as any,
        error: null as any,
        loading: false,
    });
    const [refreshIndex, setRefreshIndex] = useState(0);

    useEffect(() => {
        setState({ data: null as any, error: null as any, loading: true });
        (async () => {
            try {
                const data = await getHierarchyNodeById(id);
                setState({ data, error: null, loading: false });
            } catch (error) {
                setState({ data: null, error, loading: false });
            }
        })();
    }, [id, refreshIndex]);

    return {
        ...state,
        refresh: () => setRefreshIndex(refreshIndex + 1),
    };
}
